import { render, staticRenderFns } from "./blog-default.vue?vue&type=template&id=051f4dd8"
import script from "./blog-default.vue?vue&type=script&lang=js"
export * from "./blog-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports